<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Switch({
              label: 'Ukryty tytuł',
              modelPath: [this, 'form', 'is_title_hidden']
            }),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.WYSIWYG({
              label: 'Tekst',
              modelPath: [this, 'form', 'text'],
              multilingual: true
            }),
            new fields.Input({
              label: 'Tekst tła',
              modelPath: [this, 'form', 'bg_text'],
              multilingual: true
            }),
            new fields.Link({
              label: 'Odnośnik',
              modelPath: [this, 'form', 'price_link'],
              hideLinkLabel: true
            })
          ]
        }
      ]
    }
  }
}
</script>
